// extracted by mini-css-extract-plugin
module.exports = {"cont":"_6eb00b8e53--cont--2ZjTK","align-left":"_6eb00b8e53--align-left--2d96T","align-right":"_6eb00b8e53--align-right--2Jq69","align-center":"_6eb00b8e53--align-center--48EbV"};